import { useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React from 'react'

import ChecklistsFilter from '../../../../containers/checklists/filters/ChecklistsFilter'
import DateFilter from '../../../../components/filter/DateFilter'
import FiltersGroup from '../../../../components/filter/FiltersGroup'
import PlacesFilterGroupItems from '../../../../containers/places/filters/PlacesFilterGroupItems'
import SideModalFiltersWrapper from '../../../../components/filter/SideModalFiltersWrapper'
import StatusesFilter from '../../../../containers/statuses/filters/StatusesFilter'
import UsersFilter from '../../../../containers/users/filters/UsersFilter'

const FilterModal = ({ open, onClose }) => {
  const { t } = useTranslation(['serviceOrders', 'common'])
  const onlySelfServiceOrders = useSessionPermission('seeOnlySelfServiceOrders')

  return (
    <SideModalFiltersWrapper open={open} onClose={onClose}>
      <StatusesFilter presentation="list" />
      <ChecklistsFilter field="checklistIds" presentation="list" />
      {!onlySelfServiceOrders && <UsersFilter field="userIds" presentation="list" />}
      <UsersFilter field="createdByIds" label={t('serviceOrders:filters.createdBy')} presentation="list" />

      <PlacesFilterGroupItems
        label={t('common:places')}
        placesField="placeIds"
        placeLevelsField="placeLevelIds"
        type="location"
      />
      <PlacesFilterGroupItems
        label={t('common:people')}
        placesField="placeIds"
        placeLevelsField="placeLevelIds"
        type="person"
      />
      <PlacesFilterGroupItems
        label={t('common:fleets')}
        placesField="placeIds"
        placeLevelsField="placeLevelIds"
        type="fleet"
      />
      <FiltersGroup label={t('serviceOrders:filters.dates')}>
        <DateFilter label={t('common:creationDate')} field="insertedAt" presentation="list" />
        <DateFilter label={t('common:schedulingDate')} field="scheduling" presentation="list" />
        <DateFilter label={t('common:completionDate')} field="endDate" presentation="list" />
      </FiltersGroup>
    </SideModalFiltersWrapper>
  )
}

export default FilterModal
